import { render, staticRenderFns } from "./PostsRoute.vue?vue&type=template&id=4d09cb7e&scoped=true&"
import script from "./PostsRoute.vue?vue&type=script&lang=js&"
export * from "./PostsRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09cb7e",
  null
  
)

export default component.exports